import React, { FC } from 'react'
import styles from './Logo.module.css'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../redux/types/types'

export type LogoPropsType = {
  isWhite?: boolean
  onClick?: () => void
}

const Logo: FC<LogoPropsType> = ({ isWhite, onClick }) => {
  const { isAuth } = useAppSelector((state) => state.auth)

  const navigate = useNavigate()

  const handleLinkClick = (event: any) => {
    if (event.button === 1) {
      event.preventDefault()
      window.open('/')
    }
  }

  const onNavigateToMainPage = () => {
    if (isAuth) {
      navigate('/claim-management-page/')
    }
  }

  return (
    <div
      className={isWhite ? `${styles.whiteLogo} ${styles.logo}` : styles.logo}
      onClick={onClick || onNavigateToMainPage}
      onMouseDown={handleLinkClick}
    >
      MICEC<span className={isWhite ? styles.bigSize : styles.partOfLogo}>O</span>NNECT
    </div>
  )
}

export default Logo
